const listeners = new Set();
const LOADER_DELAY_MS = 180;

let activeRequestCount = 0;
let isLoaderVisible = false;
let showLoaderTimer = null;

const notifyListeners = () => {
  listeners.forEach((listener) => listener());
};

const clearShowTimer = () => {
  if (!showLoaderTimer) return;
  clearTimeout(showLoaderTimer);
  showLoaderTimer = null;
};

const setLoaderVisibility = (nextVisibility) => {
  if (isLoaderVisible === nextVisibility) return;
  isLoaderVisible = nextVisibility;
  notifyListeners();
};

export const beginGlobalRequest = () => {
  activeRequestCount += 1;

  if (activeRequestCount !== 1 || isLoaderVisible || showLoaderTimer) {
    return;
  }

  showLoaderTimer = setTimeout(() => {
    showLoaderTimer = null;
    if (activeRequestCount > 0) {
      setLoaderVisibility(true);
    }
  }, LOADER_DELAY_MS);
};

export const endGlobalRequest = () => {
  activeRequestCount = Math.max(0, activeRequestCount - 1);

  if (activeRequestCount > 0) {
    return;
  }

  clearShowTimer();
  setLoaderVisibility(false);
};

export const subscribeToGlobalRequestState = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const getGlobalRequestSnapshot = () => isLoaderVisible;

export const getGlobalRequestServerSnapshot = () => false;
